<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :label="label"
            :error="error"
            :errors="errors"
            :showAdd="showAdd"
            :clearable="clearable"
            :disabled="disabled"
            :dense="dense"
            :multiple="multiple"
            :itemText="itemText"
        />
    </div>
</template>

<script>

export default {
    name: 'SysSelecDayOkWeek',
    data: (vm) => ({
        days: [
            { id: 1, name: 'Domingo',       initials: 'DOM', show: vm.showSunday },
            { id: 2, name: 'Segunda-Feira', initials: 'SEG', show: true },
            { id: 3, name: 'Terça-Feira',   initials: 'TER', show: true },
            { id: 4, name: 'Quarta-Feira',  initials: 'QUA', show: true },
            { id: 5, name: 'Quinta-Feira',  initials: 'QUI', show: true },
            { id: 6, name: 'Sexta-Feira',   initials: 'SEX', show: true },
            { id: 7, name: 'Sábado',        initials: 'SÁB', show: true },
        ],
        selected: null,
        
    }),
    created() {
        this.selected = this.model;
    },
    computed: {
        items () {
            
            if(this.filter){
                return this.days.filter(i => (i.show && this.filter.includes(i.id)));
            }else{
                return this.days.filter(i => i.show);
            }
            
            
        },
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        model: {},
        multiple: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        showSunday: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        itemText: {
            type: String,
            default: 'name'
        },
        filter: {
            type: Array,
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },
    },
}
</script>